import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { AddJobApi } from "./JobAction";
import { setHeading } from "../../../accounts/account.actions";
import { GetCRMProductApi } from "../CRMProducts/CRMProductAction";
import { GetCRMCustomerApi } from "../CRMCustomer/CustomerActionCRM";
import { GetTeamMemberApi } from "../TeamMember/TeamMemberAction";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import _ from "lodash";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const AddJob = (props) => {
    const [productId, setProductId] = useState("");
    const [productName, setProductName] = useState("");
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [teamMemberId, setTeamMemberId] = useState("");
    const [teamMemberName, setTeamMemberName] = useState("");
    const [jobStatus, setJobStatus] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [financialYear, setFinancialYear] = useState("");
    const [selectedYear, setSelectedYear] = useState(null);
    const [financialMonth, setFinancialMonth] = useState("");
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [fee, setFee] = useState("");
    const [vat, setVAT] = useState("");
    const [jobFee, setJobFee] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [visibleAlert, setAlertVisible] = useState(false);
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);
    const handleChange = (date) => {
        setSelectedYear(date);
        setFinancialYear(date.getFullYear());
    };
    const handleMonthChange = (date) => {
        const monthName = date.toLocaleString('default', { month: 'long' });
        setSelectedMonth(date);
        setFinancialMonth(monthName)
    };


    function SaveJob() {
        props.AddJobApi({
            productId: productId,
            productName: productName,
            customerId: customerId,
            customerName: customerName,
            teamMemberId: teamMemberId,
            teamMemberName: teamMemberName,
            jobStatus: jobStatus,
            startDate: startDate,
            endDate: endDate,
            financialYear: financialYear,
            financialMonth: financialMonth,
            invoiceNumber: invoiceNumber,
            vat: vat,
            fee: fee,
            jobFee: jobFee,
        },
            handleVisible,
            handleDangerVisible
        );
        setProductId("");
        setProductName("");
        setJobStatus("");
        setCustomerId("");
        setCustomerName("");
        setTeamMemberId("");
        setTeamMemberName("");
        setStartDate("");
        setFinancialYear("");
        setSelectedYear("");
        setFinancialMonth("");
        setSelectedMonth("")
        setJobFee("");
        setEndDate("");
        setInvoiceNumber("");
        setVAT("");
        setFee("");
    }
    const handleVisible = (msg) => {
        setAlertVisible(true);
        setTimeout(() => {
            setAlertVisible(false);
        }, 9000);
        Swal({
            title: "Success",
            text: msg,
            icon: "success",
            button: "Ok",
        });
    };
    const handleDangerVisible = (err) => {
        setDangerVisibleAlert(true);
        setTimeout(() => {
            setDangerVisibleAlert(false);
        }, 9000);
        Swal({
            title: "Error",
            text: err,
            icon: "error",
            button: "Ok",
        });
    };

    const jobStatusList = [
        { value: "In Progress", label: "In Progress" },
        { value: "Completed", label: "Completed" },
        { value: "Not Sure", label: "Not Sure" },
        { value: "Not Accepted", label: "Not Accepted" },
    ]
    const handleChangeJobStatus = (selectedOption) => {
        setJobStatus(selectedOption.label);
    };

    const handleChangeProduct = (selectedOption) => {
        setProductId(selectedOption.value);
        setProductName(selectedOption.label);
    };
    const getProductList = props.CRMProductList?.length ? props.CRMProductList.map(x => ({
        value: x._id,
        label: x.productName
    })) : [];

    const handleChangeCustomer = (selectedOption) => {
        setCustomerId(selectedOption.value);
        setCustomerName(selectedOption.label);
    };
    const getCustomerList = props.CRMCustomerList?.length ? props.CRMCustomerList.map(x => ({
        value: x._id,
        label: x.companyName,
    })) : [];

    const handleChangeTeamMember = (selectedOption) => {
        setTeamMemberId(selectedOption.value);
        setTeamMemberName(selectedOption.label);
    };
    const getTeamMemberList = props.teamMemberList?.length ? props.teamMemberList.map(x => ({
        value: x._id,
        label: x.name,
    })) : [];

    useEffect(() => {
        props.setHeading("Add Job");
        props.GetCRMProductApi();
        props.GetCRMCustomerApi();
        props.GetTeamMemberApi();
    }, []);

    useEffect(() => {
        if (fee && vat) {
            const total = parseFloat(fee) + parseFloat(vat);
            setJobFee(total.toFixed(2));
        } else if (fee) {
            setJobFee(fee);
        } else {
            setJobFee(0);
        }
    }, [fee, vat]);

    return (
        <>
            {props.isAddingJob || props.isFetchingCRMProduct || props.isFetchingTeamMember || props.isFetchingCRMCustomer ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Sevice *</b></Form.Label>
                                    <Select
                                        placeholder="Select Sevice"
                                        onChange={handleChangeProduct}
                                        options={getProductList}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Client *</b></Form.Label>
                                    <Select
                                        placeholder="Select Client"
                                        onChange={handleChangeCustomer}
                                        options={getCustomerList}
                                        noOptionsMessage={() => "No clients found"}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Team Member *</b></Form.Label>
                                    <Select
                                        placeholder="Select Team Member"
                                        onChange={handleChangeTeamMember}
                                        options={getTeamMemberList}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Status *</b></Form.Label>
                                    <Select
                                        placeholder="Select Status"
                                        onChange={handleChangeJobStatus}
                                        options={jobStatusList}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="financialYear">
                                    <Form.Label style={{ width: '100%' }}><b>Financial Year *</b></Form.Label>
                                    <DatePicker
                                        selected={selectedYear}
                                        onChange={handleChange}
                                        showYearPicker
                                        dateFormat="yyyy"
                                        className="form-control"
                                        placeholderText="Select Year"
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="financialMonth">
                                    <Form.Label style={{ width: '100%' }}><b>Financial Month *</b></Form.Label>
                                    <DatePicker
                                        selected={selectedMonth}
                                        onChange={handleMonthChange}
                                        showMonthYearPicker  // Only shows month and year picker (no dates)
                                        dateFormat="MMMM yyyy"  // Displays as "August 2025"
                                        className="form-control"
                                        placeholderText="Select Month"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Start Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="Start Date"
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>End Date *</b></Form.Label>
                                    <Form.Control
                                        type="date"
                                        placeholder="End Date"
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Invoice Number *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Invoice Number"
                                        onChange={(e) => setInvoiceNumber(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Fee *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Fee"
                                        value={fee}
                                        onChange={(e) => setFee(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>VAT *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="VAT"
                                        value={vat}
                                        onChange={(e) => setVAT(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Job Fee *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Job Fee"
                                        value={jobFee}
                                        onChange={(e) => setJobFee(e.target.value)}
                                        disabled
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            {_.isEmpty(productId) || _.isEmpty(customerId) || _.isEmpty(teamMemberId) || _.isEmpty(jobStatus) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveJob}> SAVE </Button>
                            )}
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddJobApi: (payload, handleVisible, handleDangerVisible) => dispatch(AddJobApi(payload, handleVisible, handleDangerVisible)),
        GetCRMProductApi: () => dispatch(GetCRMProductApi()),
        GetCRMCustomerApi: () => dispatch(GetCRMCustomerApi()),
        GetTeamMemberApi: () => dispatch(GetTeamMemberApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingJob: state.JobReducer.isAddingJob,
    isFetchingCRMProduct: state.CRMProductReducer.isFetchingCRMProduct,
    CRMProductList: state.CRMProductReducer.CRMProductList,
    isFetchingCRMCustomer: state.CustomerReducerCRM.isFetchingCRMCustomer,
    CRMCustomerList: state.CustomerReducerCRM.CRMCustomerList,
    isFetchingTeamMember: state.TeamMemberReducer.isFetchingTeamMember,
    teamMemberList: state.TeamMemberReducer.teamMemberList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddJob);